import type { IconProps } from '@peacecover/icon';

const GradientCardFillIcon = ({ size = 24, className, ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
      aria-hidden="true"
    >
      <path
        d="M21.1118 8.85033L18.5526 16.6487C18.3912 17.191 18.1078 17.6892 17.7241 18.1051C17.3404 18.521 16.8667 18.8436 16.3391 19.0482C16.6193 18.3953 16.7635 17.6921 16.7627 16.9816V9.48319C16.7612 8.09159 16.2076 6.75744 15.2236 5.77343C14.2396 4.78942 12.9055 4.2359 11.5139 4.23431H10.2654C10.7284 3.62179 11.3678 3.16566 12.0977 2.9272C12.8275 2.68873 13.6129 2.67936 14.3483 2.90035L18.6118 4.20957C19.553 4.50196 20.3421 5.15176 20.8095 6.01945C21.2769 6.88713 21.3855 7.9035 21.1118 8.85033ZM15.2631 9.48319V16.9816C15.2619 17.9756 14.8665 18.9285 14.1636 19.6314C13.4608 20.3342 12.5078 20.7296 11.5139 20.7308H7.01482C6.02084 20.7296 5.06791 20.3342 4.36505 19.6314C3.6622 18.9285 3.26682 17.9756 3.26562 16.9816L3.26563 9.48319C3.26682 8.48921 3.6622 7.53628 4.36505 6.83342C5.06791 6.13057 6.02084 5.73518 7.01482 5.73399H11.5139C12.5078 5.73518 13.4608 6.13057 14.1636 6.83342C14.8665 7.53628 15.2619 8.48921 15.2631 9.48319ZM12.2637 12.4826C12.2637 12.0848 12.1057 11.7034 11.8245 11.4221C11.5432 11.1409 11.1618 10.9829 10.764 10.9829C10.3663 10.9829 9.98483 11.1409 9.70359 11.4221C9.42235 11.7034 9.26434 12.0848 9.26434 12.4826C9.26434 12.0848 9.10634 11.7034 8.8251 11.4221C8.54385 11.1409 8.1624 10.9829 7.76466 10.9829C7.36692 10.9829 6.98547 11.1409 6.70423 11.4221C6.42299 11.7034 6.26498 12.0848 6.26498 12.4826C6.26498 13.5698 7.42274 15.0253 8.30005 15.7654C8.5696 15.9934 8.91126 16.1186 9.26434 16.1186C9.61743 16.1186 9.95909 15.9934 10.2286 15.7654C11.1059 15.0253 12.2637 13.5698 12.2637 12.4826Z"
        fill="url(#paint0_linear_4104_106685)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4104_106685"
          x1="3.26562"
          y1="2.74121"
          x2="21.4065"
          y2="2.89038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#458FFF" />
          <stop offset="1" stopColor="#CF6AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GradientCardFillIcon;
